<template>
  <ol-tile-layer
    v-if="$store.state.karatay_ruhsatli.type === 'KaratayWS:kbs_yapa_ruhsatli'"
  >
    <ol-source-tile-wms
      :url="$store.state.karatay_ruhsatli.url"
      :layers="$store.state.karatay_ruhsatli.type"
    ></ol-source-tile-wms>
  </ol-tile-layer>
</template>